const homePageConstantsAr = {
  homePageWelcomeMessage: 'مرحبًا، {{name}}! الرجاء اختيار ما ترغب في إدارته من لوحة التحكم',
};

export default homePageConstantsAr;
